import React, { useEffect, useRef, useState } from 'react';

export const POSTCODE_SCRIPT = 'https://t1.kakaocdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';
let scriptPromise;
export function loadPostcode() {
  if (window.kakao?.Postcode) return Promise.resolve(window.kakao.Postcode);
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    let timer;
    const fail = () => { clearTimeout(timer); script.remove(); scriptPromise = null; reject(new Error('postcode_load_failed')); };
    script.src = POSTCODE_SCRIPT;
    script.async = true;
    script.onerror = fail;
    script.onload = () => { if (!window.kakao?.Postcode) return fail(); clearTimeout(timer); resolve(window.kakao.Postcode); };
    timer = setTimeout(fail, 12000);
    document.head.appendChild(script);
  });
  return scriptPromise;
}

export function requestAddressText(info) {
  if (!info) return '';
  return info.baseAddress ? [info.postalCode && `(${info.postalCode})`, info.baseAddress, info.detailAddress].filter(Boolean).join(' ') : info.customerAddress || '';
}

export default function RequestAddressFields({ value, onChange, disabled = false }) {
  const [open, setOpen] = useState(false);
  const [status, setStatus] = useState('');
  const [attempt, setAttempt] = useState(0);
  const container = useRef(null);
  const detail = useRef(null);
  const button = useRef(null);
  const change = useRef(onChange);
  change.current = onChange;
  useEffect(() => {
    if (!open) return undefined;
    let active = true;
    let timer;
    const node = container.current;
    setStatus('loading');
    const close = () => { if (active) { setOpen(false); button.current?.focus(); } };
    const escape = e => { if (e.key === 'Escape') close(); };
    document.addEventListener('keydown', escape);
    loadPostcode().then(Postcode => {
      if (!active) return;
      timer = setTimeout(() => { if (active) setStatus('error'); }, 12000);
      new Postcode({
        width: '100%', height: '100%',
        onresize: () => { if (active) { clearTimeout(timer); setStatus('ready'); } },
        oncomplete: data => {
          if (!active) return;
          const baseAddress = data.userSelectedType === 'R' ? data.roadAddress : data.jibunAddress;
          if (!/^\d{5}$/.test(data.zonecode || '') || !baseAddress) { setStatus('error'); return; }
          change.current({ postalCode: data.zonecode, baseAddress, detailAddress: '' });
          setOpen(false);
          detail.current?.focus();
        },
        onclose: state => { if (state === 'FORCE_CLOSE') close(); },
      }).embed(node);
    }).catch(() => { if (active) setStatus('error'); });
    return () => { active = false; clearTimeout(timer); node?.replaceChildren(); document.removeEventListener('keydown', escape); };
  }, [open, attempt]);
  const field = { boxSizing: 'border-box', width: '100%', minWidth: 0, padding: 12, border: '1px solid #d1d5db', borderRadius: 8, fontSize: 16 };
  return <div style={{ gridColumn: '1 / -1', minWidth: 0, display: 'grid', gap: 10 }}>
    <div style={{ display: 'grid', gridTemplateColumns: 'minmax(0, 1fr) auto', gap: 8 }}>
      <input aria-label="우편번호" placeholder="우편번호" value={value.postalCode} readOnly style={{ ...field, background: '#f3f4f6' }} />
      <button ref={button} type="button" disabled={disabled} onClick={() => setOpen(true)} style={{ ...field, width: 'auto', background: '#111827', color: '#fff', cursor: 'pointer' }}>주소 검색</button>
    </div>
    {open && <section aria-label="주소 검색창" style={{ border: '1px solid #d1d5db', padding: 8, borderRadius: 8 }}>
      <button type="button" onClick={() => { setOpen(false); button.current?.focus(); }} style={{ ...field, width: 'auto', marginBottom: 8 }}>검색창 닫기</button>
      {status === 'loading' && <p role="status">주소 검색을 불러오는 중입니다...</p>}
      {status === 'error' && <div role="alert">주소 검색에 연결하지 못했습니다. 연결 상태를 확인해주세요. <button type="button" onClick={() => setAttempt(n => n + 1)} style={field}>다시 시도</button></div>}
      <div ref={container} style={{ width: '100%', height: 440, maxWidth: '100%', overflow: 'hidden', display: status === 'error' ? 'none' : 'block' }} />
    </section>}
    <input aria-label="기본주소" placeholder="기본주소" value={value.baseAddress} readOnly style={{ ...field, background: '#f3f4f6' }} />
    <input ref={detail} aria-label="상세주소" placeholder="상세주소 (동·호수 등)" value={value.detailAddress} disabled={disabled} onChange={e => onChange({ ...value, detailAddress: e.target.value })} style={field} maxLength={200} />
  </div>;
}


